import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import type { CompareMode, DatePreset } from '../types';
import { loadMasterOverlayWithHealth } from './loadMasterOverlay';
import type { MasterOverlayModel } from './types';

export function useMasterOverlay(opts: {
  refreshToken?: number;
  connectionId: string;
  connection: SellerConnection | null;
  datePreset: DatePreset;
  compare: CompareMode;
}) {
  const { refreshToken = 0, connection, datePreset, compare } = opts;
  const [model, setModel] = useState<MasterOverlayModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const m = await loadMasterOverlayWithHealth({
        connection,
        datePreset,
        compare,
      });
      setModel(m);
      if (m.error) setError(m.error);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load Master Overlay');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection, datePreset, compare]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
